var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-tooltip",
    {
      attrs: {
        bottom: "",
        disabled: _vm.missingPermissionsList.length === 0 || _vm.disabled
      },
      scopedSlots: _vm._u(
        [
          {
            key: "activator",
            fn: function(ref) {
              var on = ref.on
              return [
                _c(
                  "div",
                  _vm._g(
                    { staticStyle: { width: "100%", height: "100%" } },
                    on
                  ),
                  [_vm._t("default")],
                  2
                )
              ]
            }
          }
        ],
        null,
        true
      )
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { "text-align": "left" } },
        [
          _c("span", [_vm._v(_vm._s(_vm.$t("MissingPermissions")) + ":")]),
          _vm._v(" "),
          _vm._l(_vm.missingPermissionsList, function(permission) {
            return _c("div", { key: permission }, [
              _c("span", [
                _vm._v("\n        " + _vm._s(_vm.$t(permission)) + "\n      ")
              ])
            ])
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a8df12e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a8df12e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Atoms/MissingPermissionsTooltip.vue
// module id = null
// module chunks = 